import { usePermissions } from "@/common/permission";
import type { Plugin } from "vue";

const plugin: Plugin = {
  install(app, _) {
    app.config.globalProperties.$permissionPresent =
      usePermissions().permissionPresent;
  },
};

export default plugin;
